import React from 'react';
import PropTypes from 'prop-types';

import TimeOfDayFilter from './TimeOfDayFilter/index';
import DateFilter from './DateFilter/index';
import DoctorFilter from './DoctorFilter/index';
import ServiceFilter from './ServiceFilter/index';
import styles from './filterBox.module.css';

const FilterBox = ({
  currentFilter,
  filterDoctorsByService,
  filterMorning,
  filterAfternoon,
  filterEvening,
  selectedDay,
  setMainDay,
  maxDays,
  filterDoctors,
  services,
  selectedService,
}) => (
  <div className={styles.container}>
    <DoctorFilter currentFilter={currentFilter} filterDoctors={filterDoctors} />
    <ServiceFilter
      filterDoctors={filterDoctorsByService}
      services={services}
      selectedService={selectedService}
    />
    <div className={styles.appointmentFilters}>
      <DateFilter
        maxDays={maxDays}
        selectedDay={selectedDay}
        setMainDay={setMainDay}
      />
      <TimeOfDayFilter
        filterMorning={filterMorning}
        filterAfternoon={filterAfternoon}
        filterEvening={filterEvening}
      />
    </div>
  </div>
);

FilterBox.propTypes = {
  currentFilter: PropTypes.string.isRequired,
  filterDoctorsByService: PropTypes.func.isRequired,
  filterMorning: PropTypes.func.isRequired,
  filterAfternoon: PropTypes.func.isRequired,
  filterEvening: PropTypes.func.isRequired,
  filterDoctors: PropTypes.func.isRequired,
  selectedDay: PropTypes.instanceOf(Date).isRequired,
  setMainDay: PropTypes.func.isRequired,
  maxDays: PropTypes.number,  
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FilterBox;
